export default __webpack_public_path__ + "static/media/questionMark.b3368d9f.svg";